export enum FollowTabType {
  Following,
  Followers,
}

export enum ListTabType {
  Post,
  Product,
}

export enum UserTabType {
  Post,
  Product,
  List,
  Project,
  Like,
}

export enum ProjectTabType {
  Post,
  Product,
}

export enum SearchResultTabType {
  All,
  List,
  Maker,
  Post,
  Project,
  BuilidngMaterial,
  Interior,
  Board,
  Team,
}

export enum ArchitectureResultTabType {
  Post,
  Project,
}
